//import  AuthService  from './AuthService'
import { IHostConfig } from "../../types/Tenant/IHostConfig";
import { ITenant } from "../../types/Tenant/ITenant";
import { baseApi } from "./baseApi";
import { ILoginConfig } from "../../types/Config/ILoginConfig";

export const accountApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getTenant: build.query<ITenant, string>({
            query: (tenantUrl) => "Account/TenantConfig/?tenantUrl=" + tenantUrl,
            providesTags: ["Tenant"],
        }),
        getLoginConfig: build.query<ILoginConfig, string>({
            query: (tenantUid) => `Account/${tenantUid}/LoginConfig`,
            providesTags: ["TenantLoginConfig"],
        }),
        getHostConfig: build.query<IHostConfig, string>({
            query: (tenantUid) => `Account/${tenantUid}/SystemConfig`,
            providesTags: ["HostConfig"],
        }),
    })
});

export const {
    useGetTenantQuery,
    useGetHostConfigQuery,
    useGetLoginConfigQuery,
} = accountApi;